/**
 * PostgREST filters for an agent's clients. A team owner also sees team
 * clients owned by other members. The filter is a value list, not a subquery:
 * `agent_id.in.(select ...)` is rejected with 400.
 */

function teamClientOrFilter(profileId, memberIds) {
  const personal = `and(agent_id.eq.${profileId},is_team_client.eq.false)`;
  const ids = (memberIds || []).map((id) => String(id || '').trim()).filter(Boolean);
  if (!ids.length) return personal;
  return `${personal},and(agent_id.in.(${ids.join(',')}),is_team_client.eq.true)`;
}

module.exports = { teamClientOrFilter };
